export default "__VITE_ASSET__RMwAeoS6__"